/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { AdminSystemConfigurationBodyDTO } from '../model/models';
import { ElsterConfigurationDTO } from '../model/models';
import { SystemConfigurationDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreateBusinessPremisesElsterConfigRequestParams {
    businessPremisesId: string;
    elsterConfigurationDTO: ElsterConfigurationDTO;
}

export class ClsCreateBusinessPremisesElsterConfigRequestParams {
    businessPremisesId: string = undefined;
    elsterConfigurationDTO: ElsterConfigurationDTO = undefined;
}

export interface CreateBusinessPremisesSystemConfigRequestParams {
    businessPremisesId: string;
    adminSystemConfigurationBodyDTO: AdminSystemConfigurationBodyDTO;
}

export class ClsCreateBusinessPremisesSystemConfigRequestParams {
    businessPremisesId: string = undefined;
    adminSystemConfigurationBodyDTO: AdminSystemConfigurationBodyDTO = undefined;
}

export interface DeleteBusinessPremisesElsterConfigRequestParams {
    businessPremisesId: string;
}

export class ClsDeleteBusinessPremisesElsterConfigRequestParams {
    businessPremisesId: string = undefined;
}

export interface DeleteBusinessPremisesSystemConfigRequestParams {
    businessPremisesId: string;
}

export class ClsDeleteBusinessPremisesSystemConfigRequestParams {
    businessPremisesId: string = undefined;
}

export interface GetBusinessPremisesElsterConfigRequestParams {
    businessPremisesId: string;
}

export class ClsGetBusinessPremisesElsterConfigRequestParams {
    businessPremisesId: string = undefined;
}

export interface UpdateBusinessPremisesElsterConfigRequestParams {
    businessPremisesId: string;
    ifMatch: string;
    elsterConfigurationDTO: ElsterConfigurationDTO;
}

export class ClsUpdateBusinessPremisesElsterConfigRequestParams {
    businessPremisesId: string = undefined;
    ifMatch: string = undefined;
    elsterConfigurationDTO: ElsterConfigurationDTO = undefined;
}

export interface UpdateBusinessPremisesSystemConfigRequestParams {
    businessPremisesId: string;
    ifMatch: string;
    adminSystemConfigurationBodyDTO: AdminSystemConfigurationBodyDTO;
}

export class ClsUpdateBusinessPremisesSystemConfigRequestParams {
    businessPremisesId: string = undefined;
    ifMatch: string = undefined;
    adminSystemConfigurationBodyDTO: AdminSystemConfigurationBodyDTO = undefined;
}


export interface AdminBusinessPremisesApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Create Elster configuration for business premises.
     * Create Elster configuration for business premises.
* @param requestParameters
     */
    createBusinessPremisesElsterConfig(requestParameters: CreateBusinessPremisesElsterConfigRequestParams, extraHttpRequestParams?: any): Observable<ElsterConfigurationDTO>;

    /**
     * Create system configuration for business premises.
     * Create system configuration for business premises.
* @param requestParameters
     */
    createBusinessPremisesSystemConfig(requestParameters: CreateBusinessPremisesSystemConfigRequestParams, extraHttpRequestParams?: any): Observable<SystemConfigurationDTO>;

    /**
     * Delete individual Elster configuration for business premises.
     * Delete individual Elster configuration for business premises.
* @param requestParameters
     */
    deleteBusinessPremisesElsterConfig(requestParameters: DeleteBusinessPremisesElsterConfigRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Delete individual system configuration for business premises.
     * Delete individual system configuration for business premises.
* @param requestParameters
     */
    deleteBusinessPremisesSystemConfig(requestParameters: DeleteBusinessPremisesSystemConfigRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Retrieve Elster configuration of the business premises.
     * Retrieve Elster configuration of the business premises.
* @param requestParameters
     */
    getBusinessPremisesElsterConfig(requestParameters: GetBusinessPremisesElsterConfigRequestParams, extraHttpRequestParams?: any): Observable<ElsterConfigurationDTO>;

    /**
     * Update Elster configuration for business premises.
     * Update Elster configuration for business premises.
* @param requestParameters
     */
    updateBusinessPremisesElsterConfig(requestParameters: UpdateBusinessPremisesElsterConfigRequestParams, extraHttpRequestParams?: any): Observable<ElsterConfigurationDTO>;

    /**
     * Update system configuration for business premises.
     * Update system configuration for business premises.
* @param requestParameters
     */
    updateBusinessPremisesSystemConfig(requestParameters: UpdateBusinessPremisesSystemConfigRequestParams, extraHttpRequestParams?: any): Observable<SystemConfigurationDTO>;

}
